'use strict';

exports.array = require('./array');
exports.matrix = require('./matrix');
